import { useState } from "react";
import { api } from "../../../../../../../../../utility/api";

const ENDPOINT = "cierres_mensuales_inventario";

export const CierresMensualesInventarioApi = () => {
    const [cargando, setCargando] = useState(false);

    const getCierresMensuales = async (params) => {
        try {
            setCargando(true);
            const response = await api.get(ENDPOINT, params);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const anularCierreMensual = async (id) => {
        try {
            setCargando(true);
            const response = await api.eliminar(`${ENDPOINT}/${id}`);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const obtenerReporteExcel = async (id) => {
        setCargando(true);

        const endpoint = `/api/${ENDPOINT}/${id}/excel`;

        try {
            const response = await fetch(endpoint, {
                method: "GET",
                headers: {
                    Authorization: `Token ${localStorage.getItem("token")}`,
                },
            });

            if (!response.ok) {
                // intentar obtener error real del backend
                let errorData;
                try {
                    errorData = await response.json();
                } catch (error) {
                    errorData = { detail: `Error HTTP ${response.status}` };
                }

                throw errorData;
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);

            const a = document.createElement("a");
            a.href = url;
            a.download = "resumen_existencias.xlsx";
            a.click();
        } catch (error) {
            console.error("Error al obtener reporte Excel:", error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    return {
        getCierresMensuales,
        anularCierreMensual,
        obtenerReporteExcel,

        cargando,
    };
};
